<template>
  <div class="relative d-flex flex-column">
    <label :for="id" class="form-label">
      {{ name }}
      <span v-if="required === true" class="text-danger">*</span>
    </label>
    <input
      :id="id"
      v-model="model"
      :type="dateTime === true ? 'datetime-local' : 'date'"
      :name="name"
      :class="[
        'form-control',
        {'is-invalid': error.length > 0 && serverError === true},
        {'is-valid': error.length === 0 && serverError === true},
        {[`form-control-${size}`]: size},
      ]"
      :aria-label="ariaLabel || name"
      :required="required"
      :disabled="disabled"
      :min="min ? min : undefined"
      :max="max ? max : undefined"
    />
    <span role="alert" aria-atomic="true" class="text-danger invalid-feedback">
      {{ error.length > 0 ? error : `${name} is required` }}
    </span>
    <div v-if="formText" :id="`${id}-form-text`" class="form-text">{{ formText }}</div>
  </div>
</template>
<script lang="ts" setup>
import {type BootstrapDateTimeProps} from '@/components/shared/bootstrap/forms/BootstrapDateTime/BootstrapDateTime.types';
const {modelValue, name, dateTime = true, error = ''} = defineProps<BootstrapDateTimeProps>();

const emit = defineEmits<{'update:modelValue': [value: string]}>();

const model = computed({
  get: () => modelValue,
  set: (value: string) => emit('update:modelValue', value),
});

const id = computed(() => name.toLowerCase().replace(/\s/g, ''));
</script>
